import React, { useEffect, useRef, useState } from 'react'
import CustomSelectWithSearch from '../../CustomSelectWithSearch'
import CouponLoader from '../../CouponLoader';
import { DEBOUNCING_DELAY } from '../../../utils/utils';
import { MarketDetailsFilterTabContentTypes } from '../../../types';
import {applySelectAll} from "./configData";

/**
 * This component is part of market details filter . It renders the content of the current tab
 * We dont use multiple tabs content for each of the tabs header but a single content component which renders content based on 
 * current tab.
 * @param props 
 * @returns 
 */
function MarketDetailsFilterTabContent(props: MarketDetailsFilterTabContentTypes) {
    const {options , setOptions,onSelect, selectedOptions,currentTabName ,getContent,combinedSelectedValues,loading,filterName,multiple,chipLimit, readOnly = false} = props
    
    const [searchText, setSearchText] = useState("");
    const [searchLoading, setSearchLoading] = useState<boolean>(false);

    const handleSearch = (e: any) => {
        setSearchText(e.target.value);
    }

    const lastApiCallTime = useRef<number>(0);

    async function getTabContent(searchText?:string) {
        const currApiCallTime = Date.now();
        setSearchLoading(true)
        try {
            if(currApiCallTime >= lastApiCallTime.current){
                lastApiCallTime.current = currApiCallTime;
            }
            const data = await getContent(combinedSelectedValues, currentTabName,filterName,searchText);
            
            if(currApiCallTime >= lastApiCallTime.current){
                setOptions(data[currentTabName]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            if(currApiCallTime === lastApiCallTime.current){
                setSearchLoading(false);
            }
        }
    }
    
    useEffect(() => {
        setSearchText('');
    }, [currentTabName]);

    /**
     * whenever tab changes call the api to get options
     */
    useEffect(() => {
        setSearchLoading(true); // this will show loading icon when tab changes
        const timeout = setTimeout(() => {
            getTabContent(searchText)
        }, DEBOUNCING_DELAY);
        return () => {
            setSearchLoading(false);
            return clearTimeout(timeout)
        };
    }, [currentTabName]);

    useEffect(()=>{
        if(currentTabName !== "outletCode") return

        setSearchLoading(true); // this will show loading icon text is searched
        const timeout = setTimeout(() => {
            getTabContent(searchText)
        }, DEBOUNCING_DELAY);

        return () => {
            setSearchLoading(false);
            return clearTimeout(timeout)
        };
    },[searchText])
    
    return (
        <CustomSelectWithSearch
            sort
            options={options ? [...options]:[]}
            label=''
            handleChange={onSelect}
            selectedOptions={selectedOptions ?? []}
            handleSearch={handleSearch}
            ListComponentProps={{
                style: { height: '250px', overflow: 'scroll' }
            }}
            loading={loading || searchLoading}
            showSelectedAsChip
            searchText={searchText}
            loadingIcon={<CouponLoader />}
            multiple={multiple}
            enableSelectAll={currentTabName !== "outletCode" && applySelectAll()}
            chipLimit={chipLimit}
            readOnly={readOnly}
        />
    )
}

export default React.memo(MarketDetailsFilterTabContent)